<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [header]="'CREATE_NEW_TRIGGER' | translate"
    styleClass="w-full max-w-lg!"
    (onHide)="onHide()">
    <div class="flex! w-full flex-col gap-6 py-2">
        <p-floatlabel variant="on">
            <input
                type="text"
                fluid
                pInputText
                class="w-full"
                [ngModel]="form().name"
                (ngModelChange)="updateForm({ name: $event })"
                [autofocus]="true" />
            <label>{{ 'TRIGGER_NAME' | translate }}</label>
        </p-floatlabel>

        <section class="w-full flex! items-center gap-4">
            <p-select
                class="w-full"
                styleClass="w-full"
                [ngModel]="form().triggerType"
                (ngModelChange)="updateForm({ triggerType: $event })"
                [options]="triggerTypeOptions()"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'TRIGGER_TYPE' | translate" />

            <p-select
                class="w-full"
                styleClass="w-full"
                [ngModel]="form().actionType"
                (ngModelChange)="updateForm({ actionType: $event })"
                [options]="actionTypeOptions()"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'ACTION_TYPE' | translate" />
        </section>
    </div>

    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <button pButton severity="secondary" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
            <button pButton severity="success" [loading]="creating()" [disabled]="!isValid()" (click)="confirm()">
                <i class="ph ph-plus"></i>
                {{ 'CREATE_TRIGGER' | translate }}
            </button>
        </div>
    </ng-template>
</p-dialog>
